import { Component, Inject, OnInit } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
} from '@angular/material/dialog';
import { QuoteEditItem } from '../../../overview/overview.data.service';
import { TranslateModule } from '@ngx-translate/core';
import { FlexModule } from '@angular/flex-layout';
import { MatButton } from '@angular/material/button';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { NgIf } from '@angular/common';
import { UnitTest } from '../unit-tests/unit-tests.component';

export function openTemplateUnitTestEditDialog(dialog: MatDialog, quote?: QuoteEditItem, unitTest?: UnitTest) {
    const dialogRef = dialog.open(TemplateUnitTestEditDialogComponent, {
        autoFocus: false,
        width: '500px',
        data: {
            quote,
            unitTest,
        },
    });
    return dialogRef.afterClosed();
}

export interface TemplateUnitTestEditDialogComponentData {
    quote?: QuoteEditItem;
    unitTest?: UnitTest;
}

@Component({
    selector: 'app-template-unit-test-edit-dialog',
    standalone: true,
    imports: [
        MatDialogContent,
        MatDialogTitle,
        TranslateModule,
        FlexModule,
        MatButton,
        MatDialogActions,
        MatDialogClose,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        NgIf,
    ],
    templateUrl: './template-unit-test-edit-dialog.component.html',
    styleUrl: './template-unit-test-edit-dialog.component.scss',
})
export class TemplateUnitTestEditDialogComponent implements OnInit {
    public editForm = new FormGroup({
        customerPurchaseNumber: new FormControl(this.data.quote.customerPurchaseNumber, Validators.required),
        templateDescription: new FormControl(this.data.quote.description, Validators.required),
        primarySchemes: new FormControl(this.data.quote.scheme.id),
    });

    constructor(@Inject(MAT_DIALOG_DATA) public data: TemplateUnitTestEditDialogComponentData) {}

    ngOnInit() {
        this.createEditForm();
    }

    private createEditForm() {
        this.editForm = new FormGroup({
            customerPurchaseNumber: new FormControl(this.data.quote.customerPurchaseNumber, Validators.required),
            templateDescription: new FormControl(this.data.quote.description),
            primarySchemes: new FormControl(this.data.quote.scheme.id),
        });
        if (this.data.quote.subType === 'template') {
            this.editForm.get('templateDescription')!.setValidators(Validators.required);
        } else {
            this.editForm.get('templateDescription')!.clearValidators();
        }
        this.editForm.get('templateDescription')!.updateValueAndValidity();
    }

    get dialogResult() {
        const customerPurchaseNumber = this.editForm.controls.customerPurchaseNumber.value;
        const primarySchemes = this.editForm.controls.primarySchemes.value;
        return {
            customerPurchaseNumber,
            primarySchemes,
            id: this.data.quote.id,
            ...(this.data.quote.subType === 'template' && {
                templateDescription: this.editForm.controls.templateDescription.value,
            }),
        };
    }
}
